import React, { Component } from 'react';
import {Icon} from "@blueprintjs/core";
import {List} from "immutable";
import {connect} from 'react-redux';
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";
import numeral from 'numeral';

// Components
import VirtualizedTable from "../../components/common/virtualized-table";
import WorkReportsDialog from "../../components/dialogs/ProjectWorkReportsDialog";
import {projectTasks} from "../../components/common/project-tasks";

// Actions
import {getWorkReports, createWorkReports, deleteWorkReport, cleanWorkReports, updateWorkReport} from "../../actions/work-reports";
import _ from "lodash";

// Numeral configuration
import 'numeral/locales/es-es'
import EditWorkReportDialog from '../../components/dialogs/EditWorkReportDialog';
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class ProjectWorkReports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            modalIsOpen: false,
            modalType: null,
            projectWork: {}
        }
    }
    componentDidMount() {
        this.props.getWorkReports({
            filters: {
                project: this.props.project.get('_id')
            },
            projection: 'date employee task hours cost',
            populateRefs: true
        });
    }

    componentWillUnmount() {
        this.props.cleanWorkReports();
    }

    onCanSubmit = (canSubmit) => {
        this.setState({
            canSubmit
        });
    };

    // Modal Handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false,
            canSubmit: false
        })
    };

    render() {

        // Work Reports Statistics
        let labourHours = 0, labourCosts = 0;
        this.props.workReports.forEach( report => {
            labourHours = labourHours + report.get('hours');
            labourCosts = labourCosts + report.get('cost');
        });

        // Project Work Reports Table
        const tableData = this.props.workReports;
        const tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false,
        };
        const tableColumns = {
            date: {
                title: 'Fecha',
                columnType: 'date',
                dataField: 'date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format:'DD/MM/YYYY'
            },
            employee: {
                title: "Empleado",
                columnType: 'text',
                dataField: 'employee.name',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            task: {
                title: "Tarea",
                columnType: 'text',
                dataField: 'task',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            hours: {
                title: "Horas",
                columnType: 'number',
                dataField: 'hours',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                format: '0,0.00',
                footer: { type: 'operation', value: 'sum' }
            },
            cost: {
                title: "Coste (€)",
                columnType: 'number',
                dataField: 'cost',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            edit: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'employee._id', 'task_code', 'date', 'hours', 'cost'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    return (
                        <Icon 
                            className='cursor-pointer'
                            icon='edit'
                            title='Editar'
                            iconSize={18}
                            onClick={() => {
                                this.setState({ projectWork: { 
                                    _id: value[0],
                                    employee_id: value[1],
                                    task: value[2],
                                    date: value[3],
                                    hours: value[4],
                                    cost: value[5] / value[4]
                                }});
                                this.openModal('editProjectWork');
                            }}
                        />
                    )
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (workReportId) => {
                    return (
                        <Icon className="cursor-pointer" icon="trash" title="Eliminar" onClick={() => {
                           this.props.deleteWorkReport(workReportId);
                        }} />
                    );
                }
            }
        };

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'workReportsDialog':
                    modal = {
                        width: 'large',
                        title: 'Registrar trabajo',
                        body: (
                            <WorkReportsDialog
                                onRef={ref => (this.child = ref)}
                                project={this.props.project}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                createWorkReports={this.props.createWorkReports}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSubmit}
                                    onClick={ () => this.child.onSaveButtonClick() }
                                >
                                    {'Guardar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                case 'editProjectWork':
                    modal = {
                        width: 'large',
                        title: 'Editar trabajo',
                        body : (
                            <EditWorkReportDialog
                                onRef={ref => (this.child = ref)}
                                project={this.props.project}
                                workReport={this.state.projectWork}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                updateWorkReport={this.props.updateWorkReport}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSubmit}
                                    onClick={ () => this.child.onAddButtonClick() }
                                >
                                    {'Actualizar'}
                                </button>
                            </div>
                        )
                    }
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div className="panel-body">
                <div className="row stats-zone" style={{ margin: '10px 0' }} >
                    <div className="col-auto">
                        <span className="label label-primary">{_.uniq(tableData.map(workReport => workReport.getIn(['employee', '_id'])).toJS()).length}</span>
                        <span>Empleados</span>
                    </div>
                    <div className="col-auto">
                        <span className="label label-warning">{ labourHours }</span>
                        <span>Total horas registradas</span>
                    </div>
                    <div className="col-auto">
                        <span className="label label-danger">{numeral(labourCosts).format()}</span>
                        <span>Coste de mano de obra</span>
                    </div>
                    <div className="col-auto ml-auto ">
                        <button
                            className="btn btn-primary"
                            onClick={ () => this.openModal('workReportsDialog') }
                        ><Icon icon="insert" />Registrar trabajo</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <VirtualizedTable
                            tableSettings={tableSettings}
                            tableColumns={tableColumns}
                            tableData={tableData}
                        />
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    // Reducers
    const workReportsReducer = state.workReports;

    // WorkReports
    let workReports = workReportsReducer.get('payload') || List([]);
    if (!(workReports instanceof List)) workReports = List([]);
    if (workReports.size > 0) {
        workReports = workReports.map(workReport => {
            const task = projectTasks.find(task => {
                return task.get('task_code') === workReport.get('task').toString()
            });
            const name = task && task.get('name');
            return workReport.set('task', name).set('task_code', task.get('task_code'));
        });
    }

    return {
        workReports
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getWorkReports: query => dispatch(getWorkReports(query)),
        createWorkReports: (workReports, options) => dispatch(createWorkReports(workReports, options)),
        updateWorkReport: (workReportId, workReport) => dispatch(updateWorkReport(workReportId, workReport)),
        deleteWorkReport: workReportId => dispatch(deleteWorkReport(workReportId)),
        cleanWorkReports: () => dispatch(cleanWorkReports())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectWorkReports);


// WEBPACK FOOTER //
// ./src/containers/projects/ProjectWorkReports.js